const firstRunOnboardingStorageKey = "salesko.onboarding.dismissed";

type OnboardingStorage = Pick<Storage, "getItem" | "setItem">;

export function shouldShowFirstRunOnboarding(storage: OnboardingStorage | undefined = browserLocalStorage()) {
  return storage ? storage.getItem(firstRunOnboardingStorageKey) !== "true" : false;
}

export function markFirstRunOnboardingDismissed(storage: OnboardingStorage | undefined = browserLocalStorage()) {
  storage?.setItem(firstRunOnboardingStorageKey, "true");
}

function browserLocalStorage(): OnboardingStorage | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}
